<template>
  <form-section>
    <form-item v-if="title || description" class="checkbox-wrapper">
      <checkbox
        :title="title"
        :description="description"
        v-model="checked"
        :disabled="disabled"
        :is-changed="isChanged"
        :data-qa="dataQa"
      />
      <div style="top: 0; right: 0; height: 100%; position: absolute;">
        <slot name="header-rhs"></slot>
      </div>
    </form-item>
    <div class="content" v-if="(value === 1 && showExpander) || expanderOpen">
      <slot></slot>
    </div>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import Checkbox from '@/common/components/form/Checkbox'
export default {
  name: 'FormSectionCheckbox',
  components: { Checkbox, FormItem, FormSection },
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    value: {
      required: false,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showExpander: {
      type: Boolean,
      default: true,
      required: false
    },
    isChanged: {
      type: Boolean,
      default: false,
      required: false
    },
    expanderOpen: {
      type: Boolean,
      default: false,
      required: false
    },
    dataQa: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.checked = this.value
      }
    })
  },
  watch: {
    checked() {
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style scoped>
.checkbox-wrapper {
  padding: 20px;
}
>>> .el-card__body {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 0;
}
.content {
  padding: 20px;
  border-top: 1px solid #dbdee7;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/FormSectionCheckbox.vue